// src/EnhancedComponents/theme.js
// Single source of truth for the admin look & feel (light + dark).
import { createTheme } from "@mui/material/styles";

export const DRAWER_WIDTH = 260;
export const DRAWER_WIDTH_COLLAPSED = 76;

const BRAND_NAVY = "#0b2545"; // sidebar / login hero (from the original #002744)

const theme = createTheme({
  cssVariables: { colorSchemeSelector: "class" },
  colorSchemes: {
    light: {
      palette: {
        primary: { main: "#1565c0", contrastText: "#fff" },
        secondary: { main: "#00838f" },
        success: { main: "#2e7d32" },
        warning: { main: "#ed6c02" },
        error: { main: "#d32f2f" },
        background: { default: "#f4f6fa", paper: "#ffffff" },
        divider: "#e3e8ef",
        text: { primary: "#14213d", secondary: "#5b6478" },
        // single-series chart mark, validated against the paper surface
        chart: { main: "#1565c0", track: "#e8eef7" },
        sidebar: { bg: BRAND_NAVY, text: "#c9d4e5", active: "#1e88e5" },
      },
    },
    dark: {
      palette: {
        primary: { main: "#64b5f6" },
        secondary: { main: "#4dd0e1" },
        background: { default: "#0b1220", paper: "#121a2a" },
        divider: "#223047",
        text: { primary: "#e6ebf3", secondary: "#9aa7bd" },
        chart: { main: "#4a97e6", track: "#1c2740" },
        sidebar: { bg: "#0a1424", text: "#b5c2d6", active: "#1e88e5" },
      },
    },
  },
  typography: {
    fontFamily: '"Poppins", "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif',
    h4: { fontWeight: 600 },
    h5: { fontWeight: 600 },
    h6: { fontWeight: 600 },
    subtitle1: { fontWeight: 600 },
    button: { textTransform: "none", fontWeight: 600 },
  },
  shape: { borderRadius: 10 },
  components: {
    MuiCssBaseline: {
      styleOverrides: {
        body: { WebkitFontSmoothing: "antialiased" },
      },
    },
    MuiButton: {
      defaultProps: { disableElevation: true },
      styleOverrides: { root: { borderRadius: 8 } },
    },
    MuiPaper: {
      styleOverrides: { rounded: { borderRadius: 12 } },
    },
    MuiCard: {
      defaultProps: { variant: "outlined" },
    },
    MuiTextField: {
      defaultProps: { variant: "outlined" },
    },
    MuiTooltip: {
      defaultProps: { arrow: true },
    },
    MuiTableCell: {
      styleOverrides: {
        head: ({ theme }) => ({
          fontWeight: 600,
          color: theme.vars.palette.text.secondary,
          backgroundColor: theme.vars.palette.background.paper,
        }),
      },
    },
    MuiDataGrid: {
      styleOverrides: {
        root: ({ theme }) => ({
          "& .MuiDataGrid-columnHeaderTitle": { fontWeight: 600 },
          "& .MuiDataGrid-row:hover": {
            backgroundColor: `rgba(${theme.vars.palette.primary.mainChannel} / 0.06)`,
          },
        }),
      },
    },
  },
});

export default theme;
